import React from 'react';
import {Link} from 'react-router-dom';
import Footer from './Footer.component';

const NotFound = () => {
  return (
    <React.Fragment>
      <div id='main'>
        <section id='two'>
          <div className='inner'>
            <header className='major'>
              <h2>oops! Page Not Found!</h2>
            </header>
            <p></p>
            <ul className='actions'>
              <li>
                <Link to='/' className='button next'>
                  Home
                </Link>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default NotFound;
